module.exports = __webpack_public_path__ + "6d90adc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Header/logo.png
// module id = 933
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16